import isExperienceEditor from "@utils/is-experience-editor";
var VCA = VCA || {};


VCA.ArticleSlider = (function ($) {

    var ui = {};
    var isExperienceEditor = $('#sitecore-page-mode').attr('data-attribute');

    function init() {
        cacheUI();
        addIdentigier().then(initSliders());
    }


    function cacheUI() {
        ui.$imageSlider = $('.js-image-slider');
        ui.$imageSliderThumbs = $('.js-image-slider-thumbs');
        ui.$imageSliderCations = $('.js-image-slider-caption');
    }
    function addIdentigier() {

        return new Promise((resolve) => {
            ui.$imageSlider.each(function (index, element) {
                $(this).addClass('js-image-slider' + index);
                $(this).closest('.image-slider__wrapper').find('.js-image-slider-arrows-wrap').addClass('js-image-slider-arrows-wrap' + index);
            });
    
            ui.$imageSliderCations.each(function (index, element) {
                $(this).addClass('js-image-slider-caption' + index);
            });
    
            ui.$imageSliderThumbs.each(function (index, element) {
                $(this).addClass('js-image-slider-thumbs' + index);
            });
            resolve();
          });
    }

    function initSliders() {
        initImageSliderThumbs();
        initImageSliderCations();
        initImageSlider();
    }

    function initImageSlider(e) {
        ui.$imageSlider.each(function (index, element) {
            var $status = $('.js-image-slider' + index).closest('.image-slider__wrapper').find('.js-pagingInfo');
            var hasCaptions = $('.js-image-slider-caption' + index).length;

            $('.js-image-slider' + index).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                var i = (currentSlide ? currentSlide : 0) + 1;
                $status.text(i + ' of ' + slick.slideCount);
            });

            var navSlider = '.js-image-slider-thumbs' + index +',' +  '.js-image-slider-caption' + index;
            var statusBox = '.js-image-slider-arrows-wrap' + index;
            var item_length = $('.js-image-slider' + index + ' > div').length;
            if (item_length > 1 && !isExperienceEditor) {
                $('.js-image-slider' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    rows: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: navSlider,
                    appendArrows: statusBox,
                    focusOnSelect: true,
                    accessibility: false
                });
            }else {
                $(statusBox).hide();
            }


        });


    };

    
    function initImageSliderCations(e) {
        ui.$imageSliderCations.each(function (index, element) {
            var navSlider = '.js-image-slider' + index +',' +  '.js-image-slider-thumbs' + index;
            console.log(navSlider);
            var item_length = $('.js-image-slider-caption' + index + ' > div').length;
            if (item_length > 1 && !isExperienceEditor) {
                $('.js-image-slider-caption' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: false,
                    dots: false,
                    fade: true,
                    rows: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: navSlider,
                    accessibility: false
                });
            }
        });
    };

    function initImageSliderThumbs(e) {
        ui.$imageSliderThumbs.each(function (index, element) {
            $(this).addClass('js-image-slider-thumbs' + index);
            var navSlider = '.js-image-slider' + index +',' +  '.js-image-slider-caption' + index;
            console.log(navSlider);
            var item_length = $('.js-image-slider-thumbs' + index + ' > div').length;
            if (item_length > 1 && !isExperienceEditor) {
                $('.js-image-slider-thumbs' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    rows: 0,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: navSlider,
                    focusOnSelect: true,
                    accessibility: true
                });
            }else {
                $('.js-image-slider-thumbs' + index).hide();
            }
        });
    };




    return {
        init: init
    };

})(jQuery);


$(function () {
    VCA.ArticleSlider.init();
});